module.exports = __webpack_public_path__ + "img/20200420144622695.49591937.png";